import type { ThemeMode } from '../types';

const NEXT: Record<ThemeMode, ThemeMode> = { light: 'dark', dark: 'auto', auto: 'light' };

interface ThemeToggleProps {
  theme: ThemeMode;
  onChange: (theme: ThemeMode) => void;
}

/** Three-way theme cycle: light → dark → auto. */
const ThemeToggle = ({ theme, onChange }: ThemeToggleProps) => (
  <button type="button" className="themebtn" onClick={() => onChange(NEXT[theme])}>
    Theme: {theme}
  </button>
);

export default ThemeToggle;
